import { useDeleteRevisionMutation, useUpdateRevisionMutation } from "features/api/customQuotesApi";

export const useRevisions = () => {
	const [deleteRevision, { error: deleteRevisionError, isLoading: isLoadingDelete }] = useDeleteRevisionMutation();
	const [updateRevision, { error: updateRevisionError, isLoading: isLoadingUpdate }] = useUpdateRevisionMutation();

	return {
		deleteRevision,
		updateRevision,
		deleteRevisionError,
		updateRevisionError,
		isLoadingDelete,
		isLoadingUpdate
	};
};
